module.exports = __webpack_public_path__ + "img/16.876e9abf.gif";